import type { Nullable } from 'corgi-types';

import { HTMLInputFieldType } from '../../../enums/form';
import { StateType } from '../../../enums/StateType';
import { ThemeBorderColor, ThemeTextColor } from './enums';
import type { StateProps } from './types';

export const getStateType = ({ hasError, hasWarning, hasSuccess, isLoading }: StateProps) => {
  switch (true) {
    case hasError:
      return StateType.Error;
    case hasWarning:
      return StateType.Warning;
    case hasSuccess:
      return StateType.Success;
    case isLoading:
      return StateType.Loading;
    default:
      return StateType.Default;
  }
};

export const getStateTextColor = (type: Nullable<StateType>, value?: string) => {
  switch (type) {
    case StateType.Error:
      return ThemeTextColor.Error;
    case StateType.Warning:
      return ThemeTextColor.Warning;
    case StateType.Success:
      return ThemeTextColor.Success;
    case StateType.Default:
      return value ? ThemeTextColor.Active : ThemeTextColor.Default;
    default:
      return ThemeTextColor.Active;
  }
};

export const getStateBorderColor = (type: Nullable<StateType>, value?: string) => {
  switch (type) {
    case StateType.Error:
      return ThemeBorderColor.Error;
    case StateType.Warning:
      return ThemeBorderColor.Warning;
    case StateType.Success:
      return ThemeBorderColor.Success;
    case StateType.Default:
      return value ? ThemeBorderColor.Active : ThemeBorderColor.Default;
    default:
      return ThemeTextColor.Active;
  }
};

export const isTel = (type: string) => type === HTMLInputFieldType.Tel;
